import { takeLatest } from 'redux-saga/effects';

import {
  ON_DASHBOARD_MOUNT,
  ON_DASHBOARD_MOUNT_ERROR,
  ON_DASHBOARD_TIME_FILTER_CHANGE,
  DASHBOARD_DOWNLOAD_REPORT_CLICKED,
  ON_SELECT_CUSTOM_EVENTS_COMPLETE,
  ON_SET_CUSTOM_EVENTS,
  ON_SHOW_ALL_EVENTS_CLICKED,
  ON_SELECTED_CURRENCY_CHANGE
} from '../actions';

import {
  onDashboardMount,
  getAccountReportForTimeFrame,
  redirectToHomepage,
  fetchHostReport,
  setCustomEvents
} from './sagas';

export function* onDashboardMountWatcher() {
  yield takeLatest(ON_DASHBOARD_MOUNT, onDashboardMount);
}

export function* redirectToHomepageOnMountError() {
  yield takeLatest(ON_DASHBOARD_MOUNT_ERROR, redirectToHomepage);
}

export function* fetchAccountReportOnTimeFilterChange() {
  yield takeLatest(ON_DASHBOARD_TIME_FILTER_CHANGE, getAccountReportForTimeFrame);
}

// 1 - If the user 'filters' events (selects them)
// 2 - the user 'resets' the filter (clicks Show All)
// 3 - the user changes currencies, we need to reset to the orignal state
// Ex -> filters 2 USD events, switches to CAD -> we need to re-fetch
export function* fetchAccountReportOnSelectedEventChange() {
  yield takeLatest([ON_SET_CUSTOM_EVENTS, ON_SHOW_ALL_EVENTS_CLICKED, ON_SELECTED_CURRENCY_CHANGE], getAccountReportForTimeFrame);
}

export function* dashboardDownloadReportInit() {
  yield takeLatest(DASHBOARD_DOWNLOAD_REPORT_CLICKED, fetchHostReport);
}

export function* onSelectCustomEventsComplete() {
  yield takeLatest(ON_SELECT_CUSTOM_EVENTS_COMPLETE, setCustomEvents);
}



// WEBPACK FOOTER //
// ./src/modules/dashboard/actions/watchers.js